import { render, staticRenderFns } from "./TabelaKpis.vue?vue&type=template&id=6f5b3da0&scoped=true&"
import script from "./TabelaKpis.vue?vue&type=script&lang=js&"
export * from "./TabelaKpis.vue?vue&type=script&lang=js&"
import style0 from "./TabelaKpis.vue?vue&type=style&index=0&id=6f5b3da0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b3da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
